import { computed as b } from "vue";
import { useFormDisabled as g } from "./index586.js";
import { useNamespace as v } from "./index559.js";
import { TinyColor as k } from "./index763.js";
function a(r, l = 20) {
  return r.mix("#141414", l).toString();
}
function N(r) {
  const l = g(), t = v("button");
  return b(() => {
    let e = {}, c = r.color;
    if (c) {
      const n = c.match(/var\((.*?)\)/);
      n && (c = window.getComputedStyle(window.document.documentElement).getPropertyValue(n[1]));
      const o = new k(c), i = r.dark ? o.tint(20).toString() : a(o, 20);
      if (r.plain)
        e = t.cssVarBlock({
          "bg-color": r.dark ? a(o, 90) : o.tint(90).toString(),
          "text-color": c,
          "border-color": r.dark ? a(o, 50) : o.tint(50).toString(),
          "hover-text-color": `var(${t.cssVarName("color-white")})`,
          "hover-bg-color": c,
          "hover-border-color": c,
          "active-bg-color": i,
          "active-text-color": `var(${t.cssVarName("color-white")})`,
          "active-border-color": i
        }), l.value && (e[t.cssVarBlockName("disabled-bg-color")] = r.dark ? a(o, 90) : o.tint(90).toString(), e[t.cssVarBlockName("disabled-text-color")] = r.dark ? a(o, 50) : o.tint(50).toString(), e[t.cssVarBlockName("disabled-border-color")] = r.dark ? a(o, 80) : o.tint(80).toString());
      else {
        const s = r.dark ? a(o, 30) : o.tint(30).toString(), d = o.isDark() ? `var(${t.cssVarName("color-white")})` : `var(${t.cssVarName("color-black")})`;
        if (e = t.cssVarBlock({
          "bg-color": c,
          "text-color": d,
          "border-color": c,
          "hover-bg-color": s,
          "hover-text-color": d,
          "hover-border-color": s,
          "active-bg-color": i,
          "active-border-color": i
        }), l.value) {
          const m = r.dark ? a(o, 50) : o.tint(50).toString();
          e[t.cssVarBlockName("disabled-bg-color")] = m, e[t.cssVarBlockName("disabled-text-color")] = r.dark ? "rgba(255, 255, 255, 0.5)" : `var(${t.cssVarName("color-white")})`, e[t.cssVarBlockName("disabled-border-color")] = m;
        }
      }
    }
    return e;
  });
}
export {
  a as darken,
  N as useButtonCustomStyle
};
